import { createSlice } from '@reduxjs/toolkit';

const providerForm = createSlice({
  name: 'providerForm',
  initialState: {
    name: '',
    description: '',
  },
  reducers: {
    editProviderForm(state, { payload }) {
      const { key, value } = payload;
      state[key] = value;
    },
    initProviderInfoForm(state, { payload }) {
      return payload;
    },
  },
});

const { actions, reducer } = providerForm;

export const { editProviderForm, initProviderInfoForm } = actions;

export default reducer;
